module.exports = __webpack_public_path__ + "static/media/fiveProduct.266423e7.jpeg";